import { render } from "./SkinAnalysisView.vue?vue&type=template&id=8173487a"
import script from "./SkinAnalysisView.vue?vue&type=script&lang=js"
export * from "./SkinAnalysisView.vue?vue&type=script&lang=js"

import "./SkinAnalysisView.vue?vue&type=style&index=0&id=8173487a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__